import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['icon', 'content']
  static values = {
    open: {
      type: Boolean,
      default: false
    },
    rotateIcon: {
      type: Number,
      default: 180 // Default icon rotation (in degrees)
    }
  }

  connect() {
    // Set the initial state of the accordion
    this.openValue ? this.open() : this.close()
  }

  // Toggle the 'open' value
  toggle() {
    this.openValue = !this.openValue
  }

  // Handle changes in the 'open' value
  openValueChanged(isOpen, wasOpen) {
    if (isOpen) {
      this.open()
    } else {
      this.close()
    }
  }

  // Open the accordion content
  open() {
    if (this.hasContentTarget) {
      this.revealContent()
      this.hasIconTarget && this.rotateIcon()
      this.openValue = true
    }
  }

  // Close the accordion content
  close() {
    if (this.hasContentTarget) {
      this.hideContent()
      this.hasIconTarget && this.rotateIcon()
      this.openValue = false
    }
  }

  // Reveal the accordion content
  revealContent() {
    this.contentTarget.classList.remove('hidden')
  }

  // Hide the accordion content
  hideContent() {
    this.contentTarget.classList.add('hidden')
  }

  // Rotate the accordion icon
  rotateIcon() {
    const rotateClass = 'rotate-' + this.rotateIconValue
    this.openValue
      ? this.iconTarget.classList.add(rotateClass)
      : this.iconTarget.classList.remove(rotateClass)
  }
}
